/** Display and shop fields: changing them never changes how a run plays. */
const NOT_RULES = new Set([
  'name',
  'short',
  'description',
  'blurb',
  'label',
  'price',
  'unlockLevel',
  'opensAfter',
  'available',
  'par',
  // The gold time and which route tries gave the times: goals, like par (owner, 2026-10-31).
  'goldTime',
  'routeTries',
]);

/** JSON with sorted keys and without display fields, so the same rules always give the same text. */
export function rulesJson(value: unknown): string {
  if (value === null || value === undefined) return 'null';
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : JSON.stringify(String(value));
  }
  if (typeof value === 'string' || typeof value === 'boolean') return JSON.stringify(value);
  if (ArrayBuffer.isView(value)) {
    return `[${Array.from(value as unknown as ArrayLike<number>).join(',')}]`;
  }
  if (Array.isArray(value)) return `[${value.map(rulesJson).join(',')}]`;
  const entries = Object.entries(value as Record<string, unknown>)
    .filter(([key, v]) => v !== undefined && !NOT_RULES.has(key))
    .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
  return `{${entries.map(([key, v]) => `${JSON.stringify(key)}:${rulesJson(v)}`).join(',')}}`;
}

/** A short hash of a value's rules (see {@link rulesJson}): equal values give equal hashes. */
export function rulesHash(value: unknown): string {
  return hash(rulesJson(value));
}

/** 32-bit FNV-1a over a string, as 8 hex digits. */
export function hash(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}
